import styled from 'styled-components';

export const PaymentMethodGroupStyled = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 4% 0;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PaymentMethodButtonStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  padding: 0.8em 0;
  background-color: white;
  border: solid 0.5px #ececec;
  border-radius: 10px;
  color: #111;
  font: inherit;
  font-weight: 600;
  cursor: pointer;

  :focus-visible {
    outline: 2px solid #111;
    outline-offset: 2px;
  }

  &[aria-checked='true'] {
    border: solid 2.8px #198754;
  }

  & img {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-right: 10px;
  }
`;
